import { useSelector } from "react-redux";

export const GetTranslationData = (resourceType, resourceKey) => {
  const translationData = useSelector((state) => state.translationReducer);

  if (!Array.isArray(translationData?.data)) return "";

  // Find client-specific translation first (non-zero clientId)
  const clientSpecific = translationData.data.find(
    (item) =>
      item.clientId !== 0 &&
      item.resourceType === resourceType &&
      item.resourceKey === resourceKey
  );

  if (clientSpecific) return clientSpecific.resourceValue;

  // Fallback to default client (clientId === 0)
  const defaultTranslation = translationData.data.find(
    (item) =>
      item.clientId === 0 &&
      item.resourceType === resourceType &&
      item.resourceKey === resourceKey
  );

  return defaultTranslation ? defaultTranslation.resourceValue : "";
};
